import MatchesTabContainer from './MatchesTabContainer';

export default MatchesTabContainer;
